var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Authenticator, ConfirmSignIn, RequireNewPassword, } from 'aws-amplify-react';
import { BarLoader } from 'react-spinners';
import { Auth } from '@aws-amplify/auth';
import { CognitoUserSession, CognitoUser, CognitoUserPool, CognitoIdToken, CognitoRefreshToken, CognitoAccessToken } from 'amazon-cognito-identity-js';
import { parseUrl } from 'query-string';
import LoginTheme from '../components/login/LoginTheme';
import SignIn from '../components/login/SignIn';
import VerifyContact from '../components/login/VerifyContact';
import ForgotPassword from '../components/login/ForgotPassword';
import { loginWithSessionTokenAsync, GetAWSTokensWithCode } from '../helpers/api';
import { css } from "@emotion/core";
import '@aws-amplify/ui/dist/style.css';
import './loginScreen.css';
var override = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  margin: 0 auto;\n  border-color: red;\n"], ["\n  display: block;\n  margin: 0 auto;\n  border-color: red;\n"])));
var LoginScreen = /** @class */ (function (_super) {
    __extends(LoginScreen, _super);
    function LoginScreen(props) {
        var _this = _super.call(this, props) || this;
        _this.setBackgroundImage = function (backgroundImagePath) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ backgroundImagePath: backgroundImagePath });
                localStorage.setItem('backgroundImagePath', backgroundImagePath);
                return [2 /*return*/];
            });
        }); };
        _this.SSOSignIn = function (code, redirectUrl) { return __awaiter(_this, void 0, void 0, function () {
            var _a, id_token, refresh_token, access_token, IdToken, RefreshToken, AccessToken, userPool, user, session;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, GetAWSTokensWithCode(code, redirectUrl)];
                    case 1:
                        _a = _b.sent(), id_token = _a.id_token, refresh_token = _a.refresh_token, access_token = _a.access_token;
                        IdToken = new CognitoIdToken({ IdToken: id_token });
                        RefreshToken = new CognitoRefreshToken({ RefreshToken: refresh_token });
                        AccessToken = new CognitoAccessToken({ AccessToken: access_token });
                        userPool = new CognitoUserPool({
                            UserPoolId: this.props.userPoolId,
                            ClientId: this.props.userPoolWebClientId,
                        });
                        user = new CognitoUser({
                            Username: IdToken.decodePayload().email,
                            Pool: userPool,
                        });
                        session = new CognitoUserSession({
                            IdToken: IdToken,
                            RefreshToken: RefreshToken,
                            AccessToken: AccessToken
                        });
                        user.setSignInUserSession(session);
                        // Reconfigure Auth to pickup our changes to the local storage
                        Auth.configure(this.props);
                        return [4 /*yield*/, this.tryLogin(session)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleAuthStateChange = function (state, data) {
            if (state === 'signedIn') {
                Auth.currentSession()
                    .then(_this.tryLogin)
                    .catch(function (err) { return console.log(err); });
            }
        };
        _this.onChangeUsername = function (event) {
            return _this.setState({ username: event.target.value });
        };
        _this.initFreshdeskWidget = function () { return __awaiter(_this, void 0, void 0, function () {
            var freshdeskSrc, script;
            return __generator(this, function (_a) {
                freshdeskSrc = 'https://widget.freshworks.com/widgets/61000001202.js';
                script = document.createElement('script');
                script.src = freshdeskSrc;
                script.async = true;
                document.body.appendChild(script);
                return [2 /*return*/];
            });
        }); };
        _this.tryLogin = function (session) { return __awaiter(_this, void 0, void 0, function () {
            var idToken, backgroundImagePath, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!session) return [3 /*break*/, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 7]);
                        this.setState({ loading: true });
                        idToken = session.getIdToken();
                        backgroundImagePath = localStorage.getItem('backgroundImagePath');
                        if (!backgroundImagePath) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.setBackgroundImage(backgroundImagePath)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, loginWithSessionTokenAsync(idToken.getJwtToken())];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [4 /*yield*/, Auth.signOut()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var uemail = urlParams.get('useremail');
        _this.state = {
            loading: false,
            username: uemail !== null && uemail !== void 0 ? uemail : "",
        };
        Auth.configure(__assign(__assign({}, _this.props), { authenticationFlowType: 'USER_PASSWORD_AUTH' }));
        return _this;
    }
    LoginScreen.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, _b, _c, _d, code, _e, ErrorCode, err_2;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.initFreshdeskWidget()];
                    case 1:
                        _f.sent();
                        _a = parseUrl(window.location.href), url = _a.url, _b = _a.query, _c = _b === void 0 ? {} : _b, _d = _c.code, code = _d === void 0 ? '' : _d, _e = _c.ErrorCode, ErrorCode = _e === void 0 ? '' : _e;
                        if (!ErrorCode) return [3 /*break*/, 3];
                        return [4 /*yield*/, Auth.signOut()];
                    case 2:
                        _f.sent();
                        window.location.replace(url);
                        return [3 /*break*/, 5];
                    case 3:
                        if (!code) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.SSOSignIn(code.replace('#', ''), url)];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_2 = _f.sent();
                        console.log(err_2);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    LoginScreen.prototype.componentWillMount = function () {
        // @ts-ignore
        window.fwSettings = {
            "widget_id": 61000001202
        };
    };
    LoginScreen.prototype.render = function () {
        var _this = this;
        var _a = this.state, loading = _a.loading, backgroundImagePath = _a.backgroundImagePath, username = _a.username;
        return (React.createElement("div", { style: {
                flex: 1,
                display: 'flex',
                background: 'linear-gradient(to right top, #000046, #0ca9d9)',
                backgroundAttachment: 'fixed !important',
            } },
            React.createElement("span", { style: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    backgroundImage: backgroundImagePath && "url(" + backgroundImagePath + ")",
                    backgroundAttachment: 'fixed !important',
                    backgroundPositionY: 'bottom',
                    backgroundSize: 'cover',
                    transition: 'opacity 0.5s linear',
                    opacity: backgroundImagePath ? 1 : 0
                } }),
            React.createElement("div", { style: {
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1,
                } },
                React.createElement("img", { src: "/Images/Login/Consent2GoLogo.png", style: { width: '300px', marginBottom: '20px' } }),
                React.createElement("div", { style: {
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        width: '350px',
                        overflow: 'hidden'
                    } },
                    React.createElement("div", { style: { height: 5 } },
                        React.createElement(BarLoader, { height: 5, width: 350, color: '#fc4a1a', loading: loading, css: override })),
                    React.createElement(Authenticator, { theme: LoginTheme, hideToast: true, hideDefault: true, onStateChange: this.handleAuthStateChange, 
                        //Default cause its missing and seems to prevent the page flickering?
                        authState: 'signIn' },
                        React.createElement(SignIn, { setLoading: function (loading) { return _this.setState({ loading: loading }); }, setBackgroundImage: this.setBackgroundImage, username: username, onChangeUsername: this.onChangeUsername }),
                        React.createElement(ConfirmSignIn, null),
                        React.createElement(RequireNewPassword, null),
                        React.createElement(VerifyContact, { setLoading: function (loading) { return _this.setState({ loading: loading }); } }),
                        React.createElement(ForgotPassword, { setLoading: function (loading) { return _this.setState({ loading: loading }); }, username: username, onChangeUsername: this.onChangeUsername })),
                    React.createElement("div", { id: "copyright", style: {
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            color: '#fff',
                            textAlign: 'center',
                            fontSize: '14px',
                            margin: '10px',
                            zIndex: 1
                        } }, new Date().getFullYear() + " \u00A9 MCB International ACN 149 360 743 - ",
                        React.createElement("a", { href: "/Content/Public/MCBSchoolsWebPrivacyPolicy.pdf", target: "_blank", style: { color: '#fff' } }, "Privacy Policy"))))));
    };
    return LoginScreen;
}(React.Component));
export default LoginScreen;
var templateObject_1;
//# sourceMappingURL=LoginScreen.js.map